import { tss } from "tss-react";
import Layer from "./Layer";
import ViewerActions from "actions/ViewerActions";
import { MAX_MESHSET_COUNT } from "constants/viewer";

const useStyles = tss.create({
    root: {
        position: "relative",
        display: "flex",
        height: 45,
        width: "100%",
        borderBottom: "solid 1px #E6E6E6",
        cursor: "pointer",
        transition: "opacity 2s",
        "&:hover": {
            backgroundColor: "#E6E6E6",
            transition: "opacity 0.1s",
        },
    },
});

type ISet = {
    layer: any;
    currentProject: any;
    inputs: any;
    selectedLayers: any;
    parentLayer: any;
    type?: string;
    folderLevel?: number;
    folderStatus?: string;
    folderHidden?: boolean;
    setSelectedLayers: (layer: any) => void;
    toggleSelectedLayers: (layer: any) => void;
    setLayerId: (layerId: string) => void;
    toggleVisibility: (visible: boolean, layerId: string) => void;
    setTransparency: (evt: any, layerId: string) => void;
    updateParent: () => void;
};

export default function Set(props: ISet) {
    const { classes } = useStyles();
    const { folderLevel, folderStatus, layer } = props;
    const mesh = ViewerActions.compositeMeshes[layer.ID];
    if ((folderStatus && folderStatus === "collapse") || !mesh) {
        return <div />;
    }
    const { subLayers } = mesh;
    if (subLayers.length > MAX_MESHSET_COUNT) {
        return <div />;
    }
    return subLayers.map((subLayer: any) => {
        if (subLayer.use_parent === "1") {
            subLayer = ViewerActions.inherentSpecificInputs(layer, subLayer);
        }
        return (
            <div className={classes.root} key={"subset-" + subLayer.ID}>
                <Layer
                    {...props}
                    layer={subLayer}
                    folderLevel={folderLevel ? folderLevel + 1 : 1}
                    type=""
                    draggable={false}
                    childrenCount={0}
                />
                );
            </div>
        );
    });
}
